/*
 * @Author: 朱占为
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-07-19 14:10:16
 * @LastEditTime: 2022-03-16 11:17:14
 */
import {store} from 'src/store'
// import { formatNumber } from 'vant/lib/utils';
import { createRouter, createWebHistory } from 'vue-router';
import { getCountry } from 'model/common';
import {post} from '../utils/request'
//import { EVENTS } from 'src/event.config.js';
const routes = [
  {
    path: '/wap',
    redirect: '/wap/home'
  },
  { // 首页
    path: '/wap/home',
    name: 'dashboard',
    component: () => import('../views/home/index.vue')
  },
  { // 首页的app详情
    path: '/wap/home-app',
    name: 'allApp',
    component: () => import('../views/home/homeMyApp/index.vue')
  },
  { // 订单页
    path: '/wap/order',
    name: 'Order',
    meta: {
      title: 'My Orders'
    //   head: {
    //     actionTitle: 'Save',
    //     actionEvent: EVENTS.SAVEPLAN
    //   }
    },
    component: () => import('../views/order/index.vue')
  },
  { // 个人中心
    path: '/wap/mine',
    name: 'mine',
    component: () => import('../views/mine/index.vue')
  },
  { // 下单页面
    path: '/wap/campaign',
    name: '__Add Campaign',
    component: () => import('../views/campaign/index.vue')
  },
  { // 支付
    path: '/wap/money',
    name: 'Add Money',
    component: () => import('../components/PayTypes/index.vue')
  },
  { // 支付epay
    path: '/wap/checkstand',
    name: 'Checkstand',
    component: () => import('../components/PayTypes/checkstand.vue')
  },
  { // 支付epay
    path: '/wap/checkstandresult',
    name: 'CheckstandResult',
    component: () => import('../components/PayTypes/checkstandresult.vue')
  },
  { // 服务页
    path: '/wap/support',
    name: 'support',
    meta: {
      title: 'support'
    //   head: {
    //     actionTitle: '+Add New APP',
    //     actionEvent: EVENTS.ADDAPP
    //   }
    },
    component: () => import('../views/support/index.vue')
  },
  { // 404路由
    path: '/wap/:pathMatch(.*)*',
    name: '404',
    component: () => import('../views/404/index.vue')
  },
  {
    path: '/wap/mine/memberInfo',
    name: 'Member Information',
    meta: {
      title: 'Member Information'
    },
    component: () => import('../views/mine/memberInfo/index.vue')
  },
  {
    path: '/wap/mine/transactions',
    name: 'Transactions',
    meta: {
      title: 'Transactions'
    },
    component: () => import('../views/mine/transactions/index.vue')
  },
  {
    path: '/wap/mine/team-transactions',
    name: 'Team_Transactions',
    component: () => import('../views/mine/profile/components/TeamAccount/components/TeamTransaction/index.vue')
  },
  {
    path: '/wap/mine/referral',
    name: 'Referral Program',
    component: () => import('../views/mine/referral/index.vue')
  },
  {
    path: '/wap/mine/faq',
    name: '__FAQ',
    component: () => import('../views/mine/faq/index.vue')
  },
  {
    path: '/wap/mine/bonus-program',
    name: 'Bonus Program',
    component: () => import('../views/mine/bonusProgram/index.vue')
  },
  {
    path: '/wap/mine/promo-code',
    name: 'PromoCode',
    component: () => import('../views/mine/myPromocode/index.vue')
  },
  {
    path: '/wap/mine/contact-us',
    name: '__Contact Us',
    component: () => import('../views/mine/contact/index.vue')
  },
  {
    path: '/wap/mine/my-profile',
    name: '__My Profile',
    component: () => import('../views/mine/profile/index.vue')
  },
  {
    path: '/wap/mine/my-apps',
    name: 'My Apps',
    component: () => import('../views/mine/myApp/index.vue')
  },
  {
    path: '/wap/mine/my-keywords',
    name: 'My Keywords',
    component: () => import('../views/mine/myKeywords/index.vue')
  },
  {
    path: '/wap/mine/blog',
    name: 'blog',
    component: () => import('../views/mine/Blog/index.vue')
  },
  {
    path: '/wap/message',
    name: 'Message',
    component: () => import('../views/home/components/MessagePush.vue')
  },
  {
    path: '/wap/mine/money',
    name: 'Money',
    component: () => import('../views/mine/money/index.vue')
  },
  {
    path: '/wap/mine/consumption',
    name: 'Statistics',
    component: () => import('../views/mine/consumption/index.vue')
  },
  {//退订页面
    path: '/wap/mine/unsubscribe',
    name: 'Unsubscribe',
    component: () => import('../views/mine/consumption/components/Unsubscribe.vue')
  },
  {
    path: '/wap/mine/api-support',
    name: 'ApiSupport',
    component: () => import('../views/mine/apiSupport/index.vue')
  },
  {
    path: '/wap/mine/reseller',
    name: 'Reseller',
    component: () => import('../views/mine/reseller/index.vue')
  },
  {
    path: '/wap/mine/app-intelligent-diagnosis',
    name: 'AppIntelligentDiagnosis',
    component: () => import('../views/mine/appIntelligent/index.vue')
  },
  {
    path: '/wap/empty',
    name: 'Empty',
    component: () => import('../views/Empty/index.vue')
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

const JudgmentChinaIp = async(next) => {
  const res = await post('user/isChinaMainlandIp')
  console.log((res && res.data) || res === null)
  if ((res && res.data) || res === null) {
    location.replace('/')
    next()
  } else {
    console.log('not local')
  }
}



// 路由守卫，做权限判断

router.beforeEach(async (to, from,next) => {
//   await JudgmentChinaIp(next)
  window.document.title = 'Aso World-' + to.name
  if(to.path==='/user/login'){
    next()
    return
  }
  if(to.path==='/wap/service'){
    window.Tawk_API.toggle()
    next(false)
  }
  // 跳转到官网blog
  if (to.path === '/wap/mine/blog') {
    history.pushState(null,null,'/wap/mine');//手动添加历史记录
    location.replace('/blog')
  }
  const key = 'COUNSTRY';
  if(!localStorage.getItem(key)){
    const re = await getCountry('/Region/list');
    let data = [];
    if (+re.code === 0) {
      data = re.data || [];
    }
    localStorage.setItem(key, JSON.stringify(data));
  }
  await store.dispatch('user/getAllInfo')
  const my = window.$mine
  if (my && my.id) {
    next()
  }else{
    location.replace('/user/login')
  }
  // if(from.path==='/wap/order'){
  //   store.commit('order/clearOrderForm',null)
  // }
  if(from.path==='/wap/campaign'){
    //离开页面清空appinfo
    store.commit('order/clearMyAppInfo',{})
  }
})

export default function(app) {
  router.onError(() => {
  });
  app.use(router);
  return router;
}
export {router}
